/**
 * query解析
 */

import { isObject, isString } from './type';

/**
 * 解析query-string
 * 解析后的value是经过decode的
 * @param  {string} url       query字符串
 * @param  {string} [sep='&'] 参数组分隔符，默认是&
 * @param  {string} [eq='=']  key-value分隔符，默认是=
 */
export function parse(url: string, sep = '&', eq = '=') {
  const obj: Record<string, string> = {};
  if (!url || !isString(url)) return obj;

  // 剥除url上的search之前部分和hash
  const str = url.replace(/.*?\?/, '').replace(/#.*/, '');

  const groups = str.split(sep);

  for (const group of groups) {
    const keyValue = group.split(eq);
    const key = decodeURIComponent(keyValue[0]);
    const value = decodeURIComponent(keyValue[1]);

    // only key
    if (keyValue.length === 1) {
      obj[key] = '';
      continue;
    }

    obj[key] = value;
  }

  return obj;
}

/**
 * 格式化query对象
 * 格式化后的query-string是经过encode的
 * @param  {Record<string, any>} obj query对象
 * @param  {string} [sep='&'] 参数组分隔符，默认是&
 * @param  {string} [eq='=']  key-value分隔符，默认是=
 */
export function stringify(obj: { [kesy: string]: any }, sep = '&', eq = '=') {
  if (obj == null || !isObject(obj)) return '';

  const qs: string[] = [];
  const keys = Object.keys(obj);

  for (const key of keys) {
    const value = (obj as any)[key];

    if (value === '') {
      qs.push(encodeURIComponent(key));
    } else {
      qs.push([encodeURIComponent(key), encodeURIComponent(value)].join(eq));
    }
  }

  return qs.join(sep);
}

export default { parse, stringify };
